import { NavLink } from "react-router-dom";

export default function Sidebar({ userName, canOpenAdmin, onLogout }) {
  return (
    <aside className="sidebar">
      <a className="sidebar-brand" href="https://www.motekhassesan.com/" target="_blank" rel="noopener noreferrer">
        <img className="sidebar-logo" src="https://www.motekhassesan.com/wp-content/uploads/2019/10/NEW-LOGOOoO-Copy.png" alt="لوگوی انتشارات متخصصان" />
        <span className="sidebar-brand-text">
          <span className="sidebar-brand-name">انتشارات متخصصان</span>
          <span className="sidebar-brand-sub">ردیاب بازخورد کارشناسان</span>
        </span>
      </a>

      <div className="sidebar-user">{userName}</div>

      <nav className="sidebar-nav">
        <NavLink to="/" end className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")}>
          <span className="sidebar-link-icon">🏠</span> داشبورد
        </NavLink>
        <NavLink to="/history" className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")}>
          <span className="sidebar-link-icon">🗂</span> تاریخچه باف
        </NavLink>
        {canOpenAdmin && (
          <NavLink to="/admin" className={({ isActive }) => "sidebar-link" + (isActive ? " active" : "")}>
            <span className="sidebar-link-icon">⚙</span> پنل مدیریت
          </NavLink>
        )}
      </nav>

      <button className="btn btn-danger sidebar-logout" type="button" onClick={onLogout}>خروج از حساب</button>
    </aside>
  );
}
